<template>
  <div class="container">
    <div class="live-box" v-if="lists.length > 1">
      <div
        class="item"
        v-for="(item, index) in lists"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="vedio">
          <!------------------------------------->
          <img
            :src="
              item.collectStatus === 1
                ? require('../../../static/collent_yello.png')
                : require('../../../static/menuIcon/collent-1.png')
            "
            @click.stop="toggle(item)"
            class="shoucang"
          />
          <!------------------------------------->
          <img
            :src="baseUrl + item.coverPhoto"
            class="fengmian"
            alt=""
            v-if="item.coverPhoto.includes('/hz/hzupload')"
          />
          <img src="../../../static/占位-直播-列表.png" alt="" v-else />

          <div class="fixed">
            <img src="../../../static/ico_vedio.png" alt="" />
          </div>
        </div>

        <div class="title">
          <div class="min">{{ item.liveCn }}{{ screenWidth }}</div>
          <div class="title_icon">
            <img src="../../../static/ico-time.png" alt="" />
            <div>{{ item.startDate }}</div>
          </div>
        </div>

        <div class="down">
          <p>{{ item.exhibitorNameCn }}</p>
        </div>
      </div>
    </div>
    <div v-else class="boxImg">
      <img src="../../../static/empty.png" alt="" />
      <div class="promptInfo">{{ $t("search.nodata") }}</div>
    </div>
    <div class="alert_mess" v-show="visible">
      <img class="close" @click="close" src="../../../static/close.png" />
      <div class="qrcode">
        <img :src="baseUrl + livePhoto" alt="" />
      </div>
      <p>{{ $t("common.qrCode") }}</p>
    </div>
  </div>
</template>

<script>
import { forMat, backLiveDetail } from "../../../../utils/common.js";
import { getLiveLists, collect } from "../../../../api/recommend.js";
export default {
  data() {
    return {
      baseUrl: forMat(),
      lists: [],
      screenWidth: "",
      liveDetailUrl: backLiveDetail(),
      visible: false,
      livePhoto: "",
    };
  },
  created() {
    this.getLists();
  },
  props: ["flag"],
  methods: {
    close() {
      this.visible = false;
    },
    goDetail(item) {
      switch (item.videoType) {
        case "1":
          // 视频 跳详情页
          window.location.href = this.liveDetailUrl + "?userId=" + item.id;
          break;

        case "2":
          // 直播外链 打开新窗口
          window.open(item.videoAddress);
          break;

        case "3":
          //  二维码 弹窗
          this.visible = true;
          this.livePhoto = item.videoAddress;
          break;
      }
    },
    async toggle(item) {
      let status;
      if (item.collectStatus === 0) {
        // 要添加收藏
        status = true;
      } else if (item.collectStatus === 1) {
        status = false;
      }
      const params = {
        objId: item.id,
        flag: status,
        type: 3,
      };
      try {
        const { data } = await collect(params);
        if (data.code === 200) {
          if (item.collectStatus === 0) {
            item.collectStatus = 1;
            this.$message({ message: "收藏成功！", type: "success" });
          } else {
            item.collectStatus = 0;
            this.$message({ message: "取消收藏成功！", type: "success" });
          }
        }
      } catch (err) {
        console.log(err.msg);
        this.$message.error("操作失败！");
      }

      //储存local的值，用于更新收藏数据的状态
      localStorage.setItem("collentChange", Math.random() * 10);
    },
    async getLists() {
      try {
        const { data } = await getLiveLists();
        if (data.code === 200) {
          this.lists = data.data.list;
        }
      } catch (err) {
        console.log(err.msg);
      }
    },

    //查看更多
    lookMore() {
      this.$router.push({ name: "recommendInfo", query: { tab: "3" } });
    },
  },
  watch: {
    flag(newName, oldName) {
      this.getLists();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 35vh;
  background-color: white !important;
  .live-box {
    display: grid;
    grid-template-columns: repeat(2, 48%);
    justify-content: space-between;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    padding: 0px 15px;
    box-sizing: border-box;
    padding-bottom: 35px;
    .item {
      border: 1px solid #e0e0e0;
      cursor: pointer;

      .vedio {
        width: 100%;
        position: relative;
        // 收藏与取消收藏
        .shoucang {
          width: 25px;
          height: 25px;
          position: absolute;
          right: 3px;
          top: 3px;
          z-index: 1000;
        }

        .fengmian {
          max-width: 100%;
          height: 90px;
          display: block;
          margin: 0 auto;
        }
        .fixed {
          width: 100%;
          height: 90px;
          position: absolute;
          top: 0;
          background-color: rgba(30, 30, 30, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 25px;
            max-height: 30px;
            display: block;
          }
        }
      }

      .title {
        box-sizing: border-box;
        .min {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          padding: 5px 10px;
          box-sizing: border-box;
          height: 45px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
        .title_icon {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          padding-left: 10px;
          padding-bottom: 10px;
          box-sizing: border-box;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
        }
      }
      .down {
        border-top: 1px #e0e0e0 solid;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          word-break: break-all;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 11px;
          padding: 13px 10px;
        }
      }
    }
  }
  .alert_mess {
    width: 200px;
    height: fit-content;
    box-sizing: border-box;
    padding: 5px;
    text-align: center;
    box-shadow: 0px 0px 51px 0px #c1c6cb;
    background: white;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    z-index: 99;
    .close {
      float: right;
      width: 10px;
      height: 10px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .qrcode {
      width: 150px;
      height: 150px;
      margin: 0 auto;
      margin-top: 28px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    p {
      font-size: 15px;
      font-family: Microsoft YaHei;
      margin-top: 15px;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
  }
}
</style>
<style lang="scss">
.boxImg {
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  img {
    width: 220px;
    height: 180px;
    margin: 0 auto;
  }
}
</style>
